/**
 * Check if a user has the required permission based on roles.
 * Byte-for-byte semantics of apps/auction CarFinderUtils.hasPermission.
 *
 * @param auth - Required role(s) for access (string, array, or undefined for no restriction)
 * @param roles - User's current role(s)
 * @returns True if the user has the required permission
 *
 * @example
 * hasPermission('admin', ['admin', 'user']) // true
 * hasPermission(['admin', 'moderator'], 'user') // false
 * hasPermission(undefined, 'user') // true (no restriction)
 * hasPermission([], []) // true (guests only)
 */
export function hasPermission(auth, roles) {
    // Allow access if no auth restriction is specified
    if (!auth)
        return true;
    // Only guests allowed
    if (Array.isArray(auth) && auth.length === 0) {
        return !roles || roles.length === 0;
    }
    // Handle undefined cases
    if (!roles || !auth)
        return false;
    // Normalize roles
    const roleList = Array.isArray(roles) ? roles : [roles];
    const authList = Array.isArray(auth) ? auth : [auth];
    // Check for any matching role
    return authList.some((r) => roleList.includes(r));
}
//# sourceMappingURL=has-permission.js.map